<template>
    <div class="speaker-card">
        <div v-if="speaker.sample" class="speaker-card__control">
            <SmallPlayer sync :src="speaker.sample" />
        </div>
        <div>
            <div class="speaker-card__name">
                <span v-if="speaker.is_recommended" v-tooltip="'This voice is an overall choice'">
                    ⭐
                </span>
                {{ speaker.name[$i18n.locale] }}
            </div>
            <div class="speaker-card__language">{{ speaker.language.label.eng }}</div>
            <div v-if="speaker.meta_tags && speaker.meta_tags.length" class="speaker-card__tags">
                <span v-for="tag in speaker.meta_tags" :key="tag" class="speaker-card__tag">
                    {{ tag }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { SmallPlayer } from '@speechki-frontend/shared/ui/Player';

export default {
    name: 'SpeakerCard',
    components: {
        SmallPlayer
    },

    props: {
        speaker: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" src="./SpeakerCard.scss"></style>
